import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../api/api';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => {
        // credentials can be FormData or a plain object
        return {
          url: 'api/web/v1/site/login-merchant',
          method: 'POST',
          data: credentials,
          isFormData: credentials instanceof FormData,
        };
      },
    }),
  }),
});

export const { useLoginMutation } = authApi;
